import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../../../Components/Spinner";

import ErrorMessage from "../../../Components/ErrorMessage";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../../Translations/LenguageContext";

const DeleteFileFolderModal = ({ show, handleClose, fetchRecords, message, path, activeTab }) => {
    const { t } = useLanguage()
    const { project_id } = useParams();
    const user_id = sessionStorage.getItem("user_id")
    const [error, setError] = useState({ message: "", display: false });
    const [inputValue, setInputValue] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [loadingDel, setLoadingDel] = useState(false)


    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value === path) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    };

    const handleCloseModal = () => {
        setIsButtonDisabled(true);
        handleClose()
        setError({ message: "", display: false })
        setInputValue("")
    }

    const deleteFileFolder = async () => {
        try {
            setLoadingDel(true)
            const response = await fetch(`https://backend.erioon.com/delete_codespace_item`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, project_id, filename: path, layer: activeTab }),
            });
            setLoadingDel(false)
            if (response.ok) {
                handleCloseModal()
                fetchRecords()
            } else {
                setError({ message: t.err_delete_general, display: true })
            }
        } catch (err) {
            setLoadingDel(false)
            setError({ message: t.err_delete_general, display: true })
        }
    };

    return (
        <Modal show={show} onHide={handleCloseModal} className="modal_delete">
            <div className="modal_header">
                <p>{t.delete_modal.title}</p>
                <i className="fa-solid fa-x" onClick={handleCloseModal}></i>
            </div>
            <div className="modal_body">
                <p className="warning_delete_message">{message}</p>
                <div className="delete_action_cont">
                    <p className="type_phrase_delete">{t.delete_modal.confirm_del_mex} <strong>{path}</strong></p>
                    <input
                        className="delete_input"
                        placeholder={path}
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </div>

            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className={`delete_btn ${isButtonDisabled ? "" : "delete_btn_active"}`}
                        onClick={deleteFileFolder}
                        disabled={isButtonDisabled}
                    >
                        {loadingDel ? (
                            <Spinner loading={loadingDel} />
                        ) : (
                            <>{t.delete}</>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteFileFolderModal;
